import React from 'react';
import './Body.css';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import img31 from '../../assets/img31.jpg';
// import img32 from '../../assets/img32.jpg';
import a9 from '../../assets/a9.jpg';
// import img33 from '../../assets/img33.jpg';
// import img1 from "../../assets/img1.webp"
// import img2 from "../../assets/img2.jpg"
// import img3 from "../../assets/img3.jpg"
// import slide2 from '../../assets/slide2.jpg'
import mf1 from '../../assets/mf1.avif'
import mf2 from '../../assets/mf2.avif'
import mf3 from '../../assets/mf3.avif'
import mf4 from '../../assets/mf4.avif'
import mf5 from '../../assets/mf5.avif'
import mf6 from '../../assets/mf6.avif'
import mf7 from '../../assets/mf7.avif'
import mf8 from '../../assets/mf8.avif'
import mf9 from '../../assets/mf9.avif'
import mf10 from '../../assets/mf10.avif'
import mf11 from '../../assets/mf11.avif'
import mf12 from '../../assets/mf12.avif'
import mf13 from '../../assets/mf13.avif'
import mf14 from '../../assets/mf14.avif'
import mf15 from '../../assets/mf15.avif'
import mf16 from '../../assets/mf16.avif'
import mf17 from '../../assets/mf17.avif'
import pms1 from '../../assets/pms1.avif'
import pms2 from '../../assets/pms2.avif'
import pms3 from '../../assets/pms3.avif'
import pms4 from '../../assets/pms4.avif'
import pms5 from '../../assets/pms5.avif'
import pms6 from '../../assets/pms6.avif'
import pms7 from '../../assets/pms7.avif'
import pms8 from '../../assets/pms8.avif'
import aif1 from '../../assets/aif1.avif'
import aif2 from '../../assets/aif2.avif'
import aif3 from '../../assets/aif3.avif'
import aif4 from '../../assets/aif4.avif'
import aif5 from '../../assets/aif5.avif'
// import hello from '../../assets/hello.avif'
// import pimg1 from '../../assets/pimg1.avif'
import pimg2 from '../../assets/pimg2.avif'
import pimg3 from '../../assets/pimg3.avif'


import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
// import About1 from '../about1/About1';
import Services1 from '../services1/Services1';
import TeamSection from '../team-members/TeamSection';

// import blog1 from '../../assets/blog1.jpg';
// import blog2 from '../../assets/blog2.jpg';
// import blog3 from '../../assets/blog3.jpg';
// import { CalendarDays, User } from 'lucide-react';


// const faqData = [
//     {
//         question: "Who we are?",
//         answer: "At PSJ Capital Ventures, We provide perspective, structure, and strategic clarity. Our approach is deeply rooted in research, disciplined in execution, and built around each client’s vision and financial reality.Whether you're building long-term wealth, setting up a family office, or navigating complex investment environments, we offer solutions that align your capital with your conviction. As one of the emerging top wealth management firms in India, our value lies in combining technical expertise with relationship-driven handholding.Markets are tough, so is the investing, only till you meet the right guide, who is well equipped with market knowledge and helps you in your financial journey.",
//     },
//     {
//         question: "How Many Services Do We Provide?",
//         answer: "We offer a wide range of services tailored to your needs including Holistic Wealth & Financial Planning, NRI Wealth Management, Family Office Services, Macro Research & Treasury Outlook, SME IPO Advisory & Fundraising, Curated Access to Top Fund Managers and Investment Products",
//     },
//     {
//         question: "What Is The Experience Of Our Team Members?",
//         answer: "Our team has decades of combined experience in providing top-tier solutions.",
//     },
//     {
//         question: "Our Location?",
//         answer: "1st- G - 160 2nd Floor Preet Vihar Delhi -  110092, 2nd- Plot No. E 9B Sai Industrial Park, Bhovapur, Hapur, Uttar Pradesh",
//     },
// ];


const Body = () => {

    // const [activeIndex, setActiveIndex] = useState(0);

    // const toggleFaq = (index) => {
    //     setActiveIndex(index === activeIndex ? null : index);
    // };

    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(false);


    


    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };


    useEffect(() => {
        fetchBlogs();
    }, []);


    const fetchBlogs = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.shaktitours.com/get-blog');

            if (response.ok) {
                const data = await response.json();
                console.log(data);
                data.sort((a, b) => new Date(b.added_on) - new Date(a.added_on));
                setBlogs(data);
                setLoading(false);
            } else {
                setLoading(false);
                console.error('Failed to fetch coupon');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };



    return (
        <>
            <div className="hero-section">
                <div className="hero-content">
                    <h1>We give wings to your <strong style={{ color: '#bfa350' }}>wealth creation journey!</strong></h1>
                    <p>
                        At PSJ Capital Ventures, we craft personalized wealth strategies for HNIs, Business Families,
                        Celebrities, Professionals, NRIs and Family offices seeking strategic financial guidance.

                    </p>
                    <button
                        className="hero-button"
                        onClick={() => window.open("https://forms.gle/JeYr8cGJet8gNcMG6", "_blank")}
                    >
                        Book An Appointment
                    </button>
                </div>
            </div>



            {/* three images */}
            <div className='philosophy'>
                <h1 >Our Philosophy</h1>
                <section className="services-section1">

                    <div className="service-card1">
                        <div className="card-image" style={{ backgroundImage: `url(${a9})` }}>
                            <div className="card-text">
                                <h3 className='lato-thin'>Clarity, Not Complexity</h3>
                                {/* <p>We simplify the investment journey...</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="service-card1">
                        <div className="card-image" style={{ backgroundImage: `url(${pimg2})` }}>
                            <div className="card-text">
                                <h3>Research-Led. Relationship-First</h3>
                                {/* <p>Every portfolio, plan, or strategy begins...</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="service-card1">
                        <div className="card-image" style={{ backgroundImage: `url(${pimg3})` }}>
                            <div className="card-text">
                                <h3>Wealth with Intention</h3>
                                {/* <p>Whether we’re advising on portfolio...</p> */}
                            </div>
                        </div>
                    </div>
                </section>
            </div>




            {/* about Section */}

            {/* <About1 /> */}
            {/* services */}
            <Services1 />

            {/* scrolling-strip */}

            <div class="scrolling-strip">
                <div class="scrolling-content">
                    <span>•	Holistic Wealth & Financial Planning</span>
                    <span>•	Curated Access to Top Fund Managers and Investment Products</span>
                    <span>•	NRI Wealth Management</span>
                    <span>•	Family Office Services</span>
                    <span>•	Macro Research & Treasury Outlook</span>
                    <span>•	SME IPO Advisory & Fundraising</span>

                    <span>•	Holistic Wealth & Financial Planning</span>
                    <span>•	Curated Access to Top Fund Managers and Investment Products</span>
                    <span>•	NRI Wealth Management</span>
                    <span>•	Family Office Services</span>
                    <span>•	Macro Research & Treasury Outlook</span>
                    <span>•	SME IPO Advisory & Fundraising</span>
                    <span>•	Holistic Wealth & Financial Planning</span>
                    <span>•	Curated Access to Top Fund Managers and Investment Products</span>
                    <span>•	NRI Wealth Management</span>
                    <span>•	Family Office Services</span>
                    <span>•	Macro Research & Treasury Outlook</span>
                    <span>•	SME IPO Advisory & Fundraising</span>
                    <span>•	Holistic Wealth & Financial Planning</span>
                    <span>•	Curated Access to Top Fund Managers and Investment Products</span>
                    <span>•	NRI Wealth Management</span>
                    <span>•	Family Office Services</span>
                    <span>•	Macro Research & Treasury Outlook</span>
                    <span>•	SME IPO Advisory & Fundraising</span>
                </div>
            </div>

            {/* quotes */}

            {/* <div className="insurance-quote-wrapper">
                <div className="quote-form-container">
                    <h4 className="quote-subtitle">Get Quote</h4>
                    <h2 className="quote-title">Compare quotes and get it right way.</h2>



                    <form className="quote-input-form">

                        <Link to='/calculators'><button type="submit" className="submit-quote-btn">Get a Quote Now ➜</button></Link>
                    </form>
                </div>

                <div className="quote-image-grid">
                    <div className="hex-image-wrapper">
                        <div className="hex-image-row">
                            <img src={img1} alt="Family" />
                            <img src={img2} alt="Travel" />
                            <img src={img3} alt="Love" />
                        </div>
                        <div className="hex-center-badge">4.9 Rating</div>
                        <div className="hex-image-row">
                            <img src={img3} alt="Car" />
                            <img src={img2} alt="Watch" />
                            <img src={img1} alt="House" />
                        </div>
                    </div>
                </div>
            </div> */}

            {/* your answer */}

            {/* <div className="faq-section">
                <h4 className="faq-subtitle">Your Answer</h4>
                <h2 className="faq-title">Frequently asked questions & Searching answer.</h2>

                <div className="faq-container">
                    {faqData.map((item, index) => (
                        <div className={`faq-item ${activeIndex === index ? 'active' : ''}`} key={index}>
                            <div className="faq-question" onClick={() => toggleFaq(index)}>
                                <span>{`${(index + 1).toString().padStart(2, '0')}. ${item.question}`}</span>
                                <button className="faq-toggle-btn">
                                    {activeIndex === index ? '-' : '+'}
                                </button>
                            </div>
                            {activeIndex === index && (
                                <div className="faq-answer">
                                    {item.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div> */}
            {/* team members */}

            <TeamSection />

            {/* blogs */}

            <div className="blog-section1">
                <p className="blog-subtitle1">Blog & News</p>
                <h2 className="blog-title1">Our Insights, Latest News and Updates</h2>



                <div className="blog-grid1">
  {blogs.slice(0, 3).map(blog => {
    const shortDescription = blog.description
      .split(" ")
      .slice(0, 15)
      .join(" ") + (blog.description.split(" ").length > 15 ? "..." : "");
    
    return (
      <div className="blog-card1" key={blog.id}>
        <img
          src={`https://api.shaktitours.com/pUploads/${blog.image}`}
          alt="blog1"
          className="blog-image11"
        />
        <div className="blog-meta1">
          <span>{formatDate(blog.added_on)}</span>
          <span>{blog.category}</span>
        </div>
        <h3 className="blog-heading1">{shortDescription}</h3>
      </div>
    );
  })}
</div>


                {/* <div className="blog-grid1">
                    <div className="blog-card1">
                        <img src={img31} alt="blog1" className="blog-image11" />
                        <div className="blog-meta1">
                            <span> Oct 10, 2024</span>
                            <span> PSJ</span>
                        </div>
                        <h3 className="blog-heading1">Earn good money and make you very successful</h3>
                    </div>

                    <div className="blog-card1">
                        <img src={img32} alt="blog2" className="blog-image11" />
                        <div className="blog-meta1">
                            <span> Oct 25, 2024</span>
                            <span> PSJ</span>
                        </div>
                        <h3 className="blog-heading1">Avenue money and make you very creative work</h3>
                    </div>

                    <div className="blog-card1">
                        <img src={hello} alt="blog3" className="blog-image11" />
                        <div className="blog-meta1">
                            <span> Oct 19, 2024</span>
                            <span> PSJ</span>
                        </div>
                        <h3 className="blog-heading1">Ultrices dui sapien eget mi. Enim nulla aliquet</h3>
                    </div>
                </div> */}

                <div className="view-all1">
                    <Link to='/blog'><button className="view-all-btn1">View All News →</button></Link>
                </div>
            </div>

            {/* partners */}

            <div className='testimonials'>
                <h1 class="partners-heading">Our Partners</h1><br></br><br></br>
                <h2>Mutual Funds</h2><br></br><br></br>
                <Carousel responsive={responsive} className='pb-5' arrows={true} swipeable={true} autoPlay={true} infinite={true}>
                    <div ><img src={mf2} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf1} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf3} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf4} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf5} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf6} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf7} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf8} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf9} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf10} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf11} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf12} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf13} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf14} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf15} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf16} alt='' style={{ height: '5em' }} /></div>
                    <div ><img src={mf17} alt='' style={{ height: '5em' }} /></div>
                </Carousel>
                <br></br> <br></br> <br></br> <br></br>

                <h2>Portfolio Management Services (PMS)</h2><br></br><br></br>
                <Carousel responsive={responsive} className='pb-5' arrows={true} swipeable={true} autoPlay={true} infinite={true}>
                    <div><img src={pms1} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={pms2} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={pms3} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={pms4} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={pms5} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={pms6} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={pms7} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={pms8} alt='' style={{ height: '5em' }} /></div>

                </Carousel>
                <br></br> <br></br> <br></br> <br></br>

                <h2>Alternative Investment Funds (AIFs)</h2><br></br><br></br>
                <Carousel responsive={responsive} className='pb-5' arrows={true} swipeable={true} autoPlay={true} infinite={true}>
                    <div><img src={aif1} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={aif2} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={aif3} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={aif4} alt='' style={{ height: '5em' }} /></div>
                    <div><img src={aif5} alt='' style={{ height: '5em' }} /></div>

                </Carousel>

            </div>

            <br></br><br></br><br></br><br></br>



            {/* PHILOSOPHY */}

            {/* <div className="philosophy-section">
                <h2 className="philosophy-title">OUR PHILOSOPHY</h2>
                <div className="philosophy-grid">
                    <div className="philosophy-card">
                        <img src={img1} alt="Client-Centricity" />
                        <div className="card-text1">
                            <h4 className="highlight1">Clarity, Not Complexity</h4>
                            <p>We simplify the investment journey for our clients. From first-time investors to family offices, we offer insightful, structured, and easy-to-act-on strategies. Our investment advisory services in India are built to empower, not overwhelm.</p>
                        </div>
                    </div>
                    <div className="philosophy-card">
                        <img src={img2} alt="Product Quality" />
                        <div className="card-text1">
                            <h4 className="highlight1">Research-Led. Relationship-First</h4>
                            <p>Every portfolio, plan, or strategy begins with research — macroeconomic, fundamental, and forward-looking. But numbers alone don't drive results. We believe meaningful outcomes come from long-term relationships, open dialogue, and a shared vision for your wealth.</p>
                        </div>
                    </div>
                    <div className="philosophy-card">
                        <img src={img3} alt="Long Term Focus" />
                        <div className="card-text1">
                            <h4 className="highlight1">Wealth with Intention</h4>
                            <p>Whether we’re advising on portfolio management services in India, helping an NRI family plan across borders, or assisting a founder with fundraising, our focus remains the same: to align your capital with your goals, thoughtfully and consistently.
                                Our role is not to chase markets, but to help you stay ahead of them, with conviction and clarity.
                            </p>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default Body;
